import { ReactNode } from "react";

type EmptyStateProps = {
  children: ReactNode;
};

const EmptyState = (props: EmptyStateProps) => {
  return (
    <div className="flex-grow min-h-[200px] flex items-center justify-center">
      {props.children}
    </div>
  );
};

export default EmptyState;
